function TwitterTracking(pid) {
    var url = 'https://platform.twitter.com/oct.js';
    this.logPageView = function() {
        // Set `global` as `false`: Avoid firing ajaxStart and ajaxStop, which display preloader. 
        // @see https://api.jquery.com/ajaxStart/
        $.ajax({
            url: url,
            dataType: "script",
            cache: true,
            global: false
        }).done(function() {
            twttr.conversion.trackPid(pid);
        });
    };
}